<template>
  <div class="env-ribbon" :class="envClass">
    <span>{{ $t(envLabel) }}</span>
  </div>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  env: {
    type: String,
    required: true,
  },
});

const normalized = computed(() => (props.env || "").toLowerCase());
const envLabel = computed(() => {
  if (normalized.value.includes("dev")) return "EnvRibbon.Development";
  if (normalized.value.includes("test")) return "EnvRibbon.Test";
  return normalized.value;
});
const envClass = computed(() => {
  if (normalized.value.includes("dev")) return "env-dev";
  if (normalized.value.includes("test")) return "env-test";
  return "env-other";
});
</script>

<style lang="scss" scoped>
@import "src/global_variables";

.env-ribbon {
  position: fixed;
  top: 32px;
  left: -36px;
  transform: rotate(-45deg);
  width: 164px;
  text-align: center;
  text-transform: uppercase;
  z-index: 10000000000;
  background-color: rgba(red, 0.95);
  padding: 6px 0;
  border-radius: 0;
  color: #ffffff;
  letter-spacing: 0.15em;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
}

.env-dev {
  background-color: rgba($red, 0.8);
}

.env-test {
  background-color: rgba($red, 0.8);
}

.env-other {
  background-color: rgba($grey950, 0.8);
}
</style>
